import { PageIntroSection } from "@/components/sections/page-intro";
import { ProjectsSection } from "@/components/sections/projects-section";
import { Seo } from "@/components/seo/seo";
import { useSiteContent } from "@/config/use-site-content";
import { useLocale } from "@/i18n/locale-context";
import { absoluteUrl } from "@/lib/seo-url";
import { breadcrumbJsonLd } from "@/lib/structured-data";

export function ProjectsPage(): JSX.Element {
  const { locale } = useLocale();
  const content = useSiteContent();
  const publicProjects = content.projects.items.filter(
    (item) => item.links?.length,
  );

  return (
    <>
      <Seo
        description={content.pages.projects.description}
        jsonLd={breadcrumbJsonLd([
          {
            label: content.navigation[0]?.label ?? "Home",
            url: absoluteUrl(`/${locale}`),
          },
          {
            label: content.pages.projects.title,
            url: absoluteUrl(`/${locale}/projects`),
          },
        ])}
        locale={locale}
        pathWithoutLocale="/projects"
        title={content.pages.projects.title}
      />
      <PageIntroSection content={content.pages.projects} />
      <ProjectsSection items={publicProjects} />
    </>
  );
}
